import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { ArrowLeft, Clock } from "lucide-react";
import { AuditTrailSummary } from "../summary/summary";
import { AuditTrailList } from "../list/list";
import { Button } from "@shared/ui/button";

export const AuditTrailLandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/cx/outstanding")}
          >
            <ArrowLeft size={16} />
          </Button>
          <PageHeader
            title="Bulk Communications Audit Trail"
            subtitle="Complete history of every bulk notice and bulk reminder batch executed on outstanding accounts."
          />
        </div>
      </div>

      {/* Summary Cards */}
      <AuditTrailSummary />

      {/* List Table Container */}
      <div className="bg-white p-5 rounded-xl shadow-sm border border-neutral-100">
        <AuditTrailList />
      </div>
    </div>
  );
};

export default AuditTrailLandingPage;
